<template>
  <v-row class="pt-5" v-if="results">
    <v-col cols="10" offset="1">
      <v-row>
         <v-col cols="4" v-for="(item, key) in results" :key="`${key}-${key}`">
          <p class="white--text headline mt-10">{{key|sentence}}</p>
          
          <div v-html="content" v-for="(content, index) in item" :key="`${key}-${index}}`"></div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsBlocksUser",
  data() {
    return {
      items: null,
      admins: null,
      results: {
        box1:[],
        box2:[],
        box3:[],
        box4:[],
        box5:[],
        box6:[],
      }
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getAdmins();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getExercise() {
      this.doc = null;
      let ref = fb.blocksExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.forEach((doc) => {
            let post = doc.data();
            this.getResults(post.doc)
          });
          if (items) {
            this.items = items[0];
          }
        })
        .catch(function() {});
    },
    getResults(doc) {
      this.pushToArray(doc.box1, 'box1')
      this.pushToArray(doc.box2, 'box2')
      this.pushToArray(doc.box3, 'box3')
      this.pushToArray(doc.box4, 'box4')
      this.pushToArray(doc.box5, 'box5')
      this.pushToArray(doc.box6, 'box6')
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        this.results[model].push(arr)
      }
    }
  },
};
</script>
